<template>
	<div class="detaill margin-left">
		<div class="flex bg-white list-item margin-bottom-sm">
			<img class="cover margin-right-sm" :src="logo" >
			<div class="text-left flex flex-sub flex-direction justify-between">
				<div class="titlw">{{title}}</div>
				<p class="text-sm text-666">课程章节：共{{chapterCount}}节</p>
				<div class="flex align-center justify-between">
					<p class="text-price priced text-bold text-prices">{{pay_price}}</p>
					<p class="text-center text-sm text-ccc ">{{create_time}}</p>
				</div>
			</div>
			<!-- <div class="status paied">已付款</div> -->
		</div>
		<div class="bg-white padding infoal">
			<div class="text-left infot">订单信息</div>
			<div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">订单编号</p>
					<p>{{order_no}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">下单时间</p>
					<p>{{create_time}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">课程类型</p>
					<p>{{category_name}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">课程名称</p>
					<p>{{title}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">应付金额</p>
					<p class="text-price text-prices">{{pay_price}}</p>
				</div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">支付方式</p>
					<p class="">微信支付</p>
				</div>
				<div class="flex align-center margin-bottom-sm">
					<p class="titlr text-999">课程模式</p>
					<p>{{type == 0?'视频课程':'文件课程'}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id:0,
				category_name:'',
				create_time:'',
				logo:'',
				order_no:'',
				pay_price:'',
				title:'',
				type:'',
				course_id:0,//课程id
				status:0,
				chapterCount:0,
				true_price:'',
			};
		},
		created() {
			Bus.$on('saledeti',data=>{
				this.id = data
				this.getdetail()
			})
		},
		destroyed() {
			Bus.$off('saledeti')
		},
		methods: {
			getdetail(){
				this.ajax('get', '/api/user/getMySellInfo',{
					id:this.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.type = res.data.type
						this.logo = res.data.logo
						this.title = res.data.title
						this.pay_price = res.data.price
						this.create_time = res.data.create_time
						this.order_no = res.data.order_no
						this.chapterCount = res.data.chapterCount
						this.category_name = res.data.course_category.category_name
						this.true_price = res.data.true_price
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.detaill{
		width: 921px;
	}
	.titlr{
		width: 102px;
		text-align: left;
	}
	.infot{
		font-size: 26px;
		margin-bottom: 38px;
	}
	.infoal{
		height: 451px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
	}
	.list-item{
		padding: 30px;
		border-radius: 20px;
		width: 921px;
		position: relative;
		.status{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.paied{
			background: rgba(11,131,124,0.1000);
			color: #0B837C;
		}
		.paybtn{
			width: 193px;
			height: 45px;
			line-height: 45px;
			color: #fff;
			background: #0B837C;
			border-radius: 23px;
		}
		.priced{
			font-size: 34px;
		}
	}
	.cover{
		width: 118px;
		height: 151px;
	}
	.titlw{
		font-size: 26px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/course/sale-detail.vue